function sendToWideDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/send-to-wide/send-to-wide-dialog.html?$$REVISION$$'
  }
}

export { sendToWideDialog }
